import { z } from 'zod'

/**
 * `LGH-046`. The operator-direct front door onto `DR-037`'s own atomic
 * `Tenant`+`User`+`TenantMembership(role: ADMIN)` create — the same
 * operation `accept-named` uses, reached with no `OnboardingRequest`
 * involved. Wire shape from `1C`'s own answer,
 * `REQ-lighthouse-operator-direct-tenant-creation-endpoint`, live-verified:
 * `POST /api/v1/operator/tenants`.
 *
 * **Field list is the founder's own settled ruling** (`LGH-046`, 2026-09-18)
 * — `tenantName` alone for the tenant, `adminName`/`adminPhone` required,
 * `adminEmail` optional, no password field anywhere, ever.
 */
export const createOperatorTenantRequestSchema = z.object({
  tenantName: z.string().min(1),
  adminName: z.string().min(1),
  adminPhone: z.string().min(1),
  adminEmail: z.string().min(1).optional(),
})
export type CreateOperatorTenantRequest = z.infer<typeof createOperatorTenantRequestSchema>

/**
 * `membershipId` is `TenantMembership`'s own composite primary key
 * (`tenant_id:user_id` — the table has no single `id` column), per `1C`'s
 * own answer — a representation of the real identity, not an invented one.
 */
export const createOperatorTenantResponseSchema = z
  .object({
    tenantId: z.string(),
    userId: z.string(),
    membershipId: z.string(),
  })
  .strict()
export type CreateOperatorTenantResponse = z.infer<typeof createOperatorTenantResponseSchema>
